import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { dinner } from "../data/menuData";

// Homepage menu preview — sources from the authoritative menuData.js (dinner).
const previewCats = ["Raw Bar", "Starters", "Steaks & Chops", "Seafood", "Sides"];

export const MenuExperience = () => {
  const [active, setActive] = useState(previewCats[0]);
  const items = (dinner.subcats[active] || []).slice(0, 6);

  return (
    <div>
      {/* Category tabs */}
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 border-b border-black/10 pb-6 mb-12">
        {previewCats.map((cat) => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            data-testid={`menu-cat-${cat.toLowerCase().replace(/\s/g, "-")}`}
            className={`relative text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase transition-colors duration-300 ${
              active === cat ? "text-[#1a1817]" : "text-[#6d6661] hover:text-[#1a1817]"
            }`}
          >
            {cat}
            {active === cat && (
              <motion.span layoutId="menu-underline" className="absolute -bottom-[25px] left-0 right-0 h-px bg-[#C1272D]" />
            )}
          </button>
        ))}
      </div>

      {/* Dishes */}
      <AnimatePresence mode="wait">
        <motion.div
          key={active}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-4xl mx-auto"
          data-testid={`menu-items-${active.toLowerCase().replace(/\s/g, "-")}`}
        >
          {items.map((dish) => (
            <div key={dish.name} className="flex items-baseline gap-4 group">
              <div className="flex-1">
                <h4 className="font-serif text-2xl text-[#1a1817] group-hover:text-[#9E1F24] transition-colors leading-tight">
                  {dish.name}
                </h4>
                {dish.desc && <p className="text-[#6d6661] text-sm font-light mt-1 leading-relaxed">{dish.desc}</p>}
              </div>
              <div className="flex-1 border-b border-dotted border-black/20 mb-1.5 min-w-[16px]" />
              <span className="font-serif text-xl text-[#C1272D] whitespace-nowrap">
                {dish.price ? (String(dish.price).includes("MP") ? dish.price : `$${dish.price}`) : "MP"}
              </span>
            </div>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
